// src/actions/inbox/index.js
import ActionType from '../ActionType'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'
import { sendSMS } from 'actions/sms'
import { sendEmail } from 'actions/email'
import { list, read } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'
// import questionsAndAnswers from './questionsAndAnswers'
const Handlebars = require('handlebars')

export const listInbox =
  ({ infiniteLoader, recursive, endpoint }) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const vr_account_id =
        getState().auth?.session?.idToken?.payload?.['custom:vr_account_id']
      const status = getState().data?.['account/ap/status']
      const cursorValue =
        getState().inbox.conversationsListCursor?.[endpoint]?.cursor || ''

      if (infiniteLoader) {
        dispatch({ type: ActionType.Inbox.LIST_REQUEST, endpoint })
      }

      const listFn = () => {
        // const cursorValue = cursorState.cursor
        const username =
          getState().auth.session?.idToken?.payload?.['cognito:username']
        const user = getState().inbox.conversationsListUserFilter.filter
        const endpointNew =
          endpoint || getState().inbox.conversationsListFilter || 'all'

        return dispatch(
          list(
            `inbox${endpointNew !== 'all' ? '/' + endpointNew : ''}`,
            'contact_id',
            null,
            null,
            null,
            null,
            `?pageSize=1000${
              user === 'all' || user === 'unassigned'
                ? ''
                : `&user=${user || username}`
            }${cursorValue ? `&cur=${cursorValue}` : ''}`,
          ),
        ).then(payload => {
          dispatch({
            type: ActionType.Inbox.LIST_SUCCESS,
            payload: payload.response,
            newConversationSelected: getState().inbox.newConversationSelected,
            cursor: payload.cursor,
            endpoint: endpointNew,
          })
          resolve(payload)
        })
      }

      if (!recursive) {
        const inboxfilterID = `inboxfilter-${
          getState().auth.session?.idToken?.payload?.['cognito:username']
        }-${vr_account_id}`

        return dispatch(
          read(
            inboxfilterID,
            'inboxfilter',
            null,
            null,
            'object',
            null,
            null,
            `${DATA_API_URL}/inboxfilter/${inboxfilterID}`,
          ),
        ).then(inboxfilterPayload => {
          const inboxuserfilterID = `inboxuserfilter-${
            getState().auth.session?.idToken?.payload?.['cognito:username']
          }-${vr_account_id}`

          return dispatch(
            read(
              inboxuserfilterID,
              'inboxuserfilter',
              null,
              null,
              'object',
              null,
              null,
              `${DATA_API_URL}/inboxuserfilter/${inboxuserfilterID}`,
            ),
          ).then(inboxuserfilterPayload => {
            if (inboxuserfilterPayload) {
              return listFn()
            } else {
              if (typeof status !== 'object') {
                return dispatch(
                  read(null, 'account/ap/status', null, 'none'),
                ).then(payload => {
                  return listFn()
                })
              }
            }
          })
        })
      } else {
        return listFn()
      }
    })

export const listInboxFn =
  ({ pageSize = '1000', cur, user, endpoint = 'all' }) =>
  async (dispatch, getState) => {
    try {
      const payload = await dispatch(
        list(
          `inbox${endpoint !== 'all' ? '/' + endpoint : ''}`,
          'contact_id',
          null,
          null,
          null,
          null,
          `?pageSize=${pageSize}${user ? `&user=${user}` : ''}${
            cur ? `&cur=${cur}` : ''
          }`,
        ),
      )

      dispatch({
        type: ActionType.Inbox.LIST_SUCCESS,
        payload: payload.response,
        newConversationSelected: getState().inbox.newConversationSelected,
        cursor: payload.cursor,
        endpoint,
      })

      return payload
    } catch (error) {
      console.log('listInboxFn error: ', error)
    }
  }

export const getFilterPreference = () => async (dispatch, getState) => {
  try {
    const vr_account_id =
      getState().auth?.session?.idToken?.payload?.['custom:vr_account_id']

    const inboxfilterID = `inboxfilter-${
      getState().auth.session?.idToken?.payload?.['cognito:username']
    }-${vr_account_id}`

    const filterPreference = await dispatch(
      read(
        inboxfilterID,
        'inboxfilter',
        null,
        null,
        'object',
        null,
        null,
        `${DATA_API_URL}/inboxfilter/${inboxfilterID}`,
      ),
    )

    return filterPreference
  } catch (error) {
    console.log('getFilterPreference error: ', error)
  }
}

export const getUserFilterPreference = () => async (dispatch, getState) => {
  try {
    const vr_account_id =
      getState().auth?.session?.idToken?.payload?.['custom:vr_account_id']

    const inboxuserfilterID = `inboxuserfilter-${
      getState().auth.session?.idToken?.payload?.['cognito:username']
    }-${vr_account_id}`

    const userFilterPreference = await dispatch(
      read(
        inboxuserfilterID,
        'inboxuserfilter',
        null,
        null,
        'object',
        null,
        null,
        `${DATA_API_URL}/inboxuserfilter/${inboxuserfilterID}`,
      ),
    )

    return userFilterPreference
  } catch (error) {
    console.log('getUserFilterPreference error: ', error)
  }
}

export const whatever = payload => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({
      type: 'whatever',
      payload,
    })
    resolve()
  })

export const selectConversation = payload => (dispatch, getState) => {
  const contact = getState().contacts.contactsWithEmailsByID?.[payload]

  return Promise.resolve(
    dispatch({
      type: ActionType.Inbox.SELECT_CONVERSATION,
      payload,
      contact,
    }),
  )
}
export const toggleContactViewPanel = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.TOGGLE_CONTACT_VIEW_PANEL,
    payload,
  })

export const toggleThreadView = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.TOGGLE_THREAD_VIEW,
    payload,
  })

export const toggleChatSearch = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.TOGGLE_CHAT_SEARCH,
    payload,
  })

export const changeValue = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.TOGGLE_CHAT_SEARCH,
    payload,
  })

export const handleSearchOptionsChange = (property, payload) => dispatch =>
  dispatch({
    type: ActionType.Inbox.HANDLE_SEARCH_OPTIONS_CHANGE,
    property,
    payload,
  })

export const searchConversationsList = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.SEARCH_CONVERSATIONS_LIST,
    payload,
  })

export const filterConversationsList = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.FILTER_CONVERSATIONS_LIST,
    payload,
  })

export const toggleHideStopRequests = payload => dispatch =>
  dispatch({ type: 'toggleHideStopRequests', payload })

// export const filterUserConversationsList = payload => dispatch =>
//   dispatch({
//     type: ActionType.Inbox.FILTER_USER_CONVERSATIONS_LIST,
//     payload,
//   })

export const contactSearch = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.CONTACT_SEARCH,
    payload,
  })

export const selectContact = idOrObj => (dispatch, getState) => {
  const payload =
    typeof idOrObj === 'object'
      ? idOrObj
      : getState().contacts.contactsWithEmailsByID?.[idOrObj]

  dispatch({
    type: ActionType.Inbox.SELECT_CONTACT,
    payload,
  })
}

export const selectContactOrConversation =
  contactID => (dispatch, getState) => {
    const inbox = getState().data?.inbox

    if (inbox[contactID]) {
      dispatch(selectConversation(contactID))
      dispatch(read(contactID, 'inbox', 'inbox/conversation', 'contact_id'))
    } else {
      dispatch(selectContact(contactID))
    }
  }

export const changeTo = (messageType, payload, contactID) => dispatch =>
  Promise.resolve(
    dispatch({
      type: ActionType.Inbox.CHANGE_TO,
      messageType,
      payload,
      contactID,
    }),
  )

export const readEmail = endpoint => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({ type: ActionType.Inbox.READ_EMAIL_REQUEST, endpoint })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}${endpoint}`, {
          cache: 'no-cache',
          // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(
            payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Inbox.READ_EMAIL_FAILURE,
                  payload,
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.Inbox.READ_EMAIL_SUCCESS,
                payload,
              })
              resolve(payload)
            },
            error => {
              dispatch({
                type: ActionType.Inbox.READ_EMAIL_FAILURE,
                payload: error,
                endpoint,
              })
              reject(error)
            },
          )
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const toggleEmailDialog = (uri, template) => (dispatch, getState) => {
  const emailsLoaded = getState().inbox.emailsLoaded
  const text = Handlebars.compile(emailsLoaded?.[uri]?.content?.html_body || '')

  dispatch({
    type: ActionType.Inbox.TOGGLE_EMAIL_DIALOG,
    payload: text(template),
  })
}

export const changeMessageType =
  (selected = null, manuallySelected) =>
  dispatch =>
    dispatch({
      type: ActionType.Inbox.CHANGE_MESSAGE_TYPE,
      payload: { selected, manuallySelected },
    })

export const sendSMSInbox = payload => dispatch => {
  dispatch({
    type: ActionType.Inbox.SEND_SMS,
    payload,
  })

  const { text, contact_id, to, from_number, media_url } = payload

  return dispatch(sendSMS(text, contact_id, to, from_number, media_url))
}

export const sendEmailInbox =
  (payload, bodyOverride) => (dispatch, getState) => {
    const fromEmailSelected = getState().inbox.fromEmailSelected
    const from = fromEmailSelected?.address
    const fromName = getState().inbox.fromName

    const accountInfo = getState().auth?.session?.idToken?.payload

    const from_name =
      fromName ||
      fromEmailSelected?.display_name ||
      `${accountInfo?.given_name ? `${accountInfo.given_name} ` : ''}${
        accountInfo?.family_name || ''
      }`

    dispatch({
      type: ActionType.Inbox.SEND_EMAIL,
      payload,
    })

    return Promise.resolve(
      dispatch(
        sendEmail(null, true, { ...payload, from, from_name }, bodyOverride),
      ),
    )
  }

export const selectNewConversation = payload => dispatch => {
  dispatch({
    type: ActionType.Inbox.SELECT_NEW_CONVERSATION,
    payload,
  })
}

export const call = () => (dispatch, getState) => {
  const fromNumberSelected = getState().inbox.fromNumberSelected
  const toNumberSelected = getState().inbox.to

  dispatch({
    type: ActionType.Inbox.CALL,
    toNumberSelected,
    fromNumberSelected,
  })
}

export const selectFromNumber = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.SELECT_FROM_NUMBER,
    payload,
  })

export const selectFromEmail = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.SELECT_FROM_EMAIL,
    payload,
  })

export const changeFromName = payload => dispatch =>
  dispatch({
    type: ActionType.Inbox.CHANGE_FROM_NAME,
    payload,
  })

export const replyToEmail = (payload, contact) => dispatch =>
  dispatch({
    type: ActionType.Inbox.REPLY_TO_EMAIL,
    payload,
    contact,
  })

export const clearFilters = () => dispatch =>
  dispatch({
    type: ActionType.Inbox.CLEAR_FILTERS,
  })

export const toggleMessageMenu = payload => dispatch =>
  new Promise((resolve, reject) => {
    resolve(
      dispatch({
        type: ActionType.Inbox.TOGGLE_MESSAGE_MENU,
        payload,
      }),
    )
  })

export const setLoadingAll = (payload, endpoint) => (dispatch, getState) =>
  Promise.resolve(
    dispatch({
      type: 'Inbox.SET_LOADING_ALL',
      payload,
      endpoint: endpoint || getState().inbox.conversationsListFilter,
    }),
  )

export const setLoading = (payload, endpoint) => (dispatch, getState) =>
  Promise.resolve(
    dispatch({
      type: 'Inbox.SET_LOADING',
      payload,
      endpoint: endpoint || getState().inbox.conversationsListFilter,
    }),
  )

export const setEmptyPage = (payload, endpoint) => (dispatch, getState) =>
  Promise.resolve(
    dispatch({
      type: 'Inbox.SET_EMPTY_PAGE',
      payload,
      endpoint: endpoint || getState().inbox.conversationsListFilter,
    }),
  )

export const setCursor = (payload, endpoint) => (dispatch, getState) =>
  Promise.resolve(
    dispatch({
      type: 'Inbox.SET_CURSOR',
      payload,
      endpoint: endpoint || getState().inbox.conversationsListFilter,
    }),
  )

export const clearNeedsFollowUp = payload => dispatch =>
  Promise.resolve(
    dispatch({
      type: 'Inbox.CLEAR_NEEDS_FOLLOW_UP',
      payload,
    }),
  )

export const setNeedsFollowUp = payload => dispatch =>
  Promise.resolve(
    dispatch({
      type: 'Inbox.SET_NEEDS_FOLLOW_UP',
      payload,
    }),
  )

export const clearRecentViewable = payload => dispatch =>
  Promise.resolve(
    dispatch({
      type: 'Inbox.CLEAR_RECENT_VIEWABLE',
      payload,
    }),
  )

export const setRecentViewable = payload => dispatch =>
  Promise.resolve(
    dispatch({
      type: 'Inbox.SET_RECENT_VIEWABLE',
      payload,
    }),
  )

export const overrideSmsInput = payload => dispatch =>
  Promise.resolve(dispatch({ type: 'Inbox.OVERRIDE_SMS_INPUT', payload }))

export const sendSmsInboxDefault = (text, to) => (dispatch, getState) => {
  const inbox = getState().inbox
  const contact_id = inbox.contactSelected?.id || inbox.conversationSelected
  const contact =
    inbox.contactSelected ||
    (inbox.conversationSelected && inbox.conversation?.contact)
  const toValue = to || inbox.to.current.value
  const from_number = inbox.fromNumberSelected.phone_number
  const contactSelected = Boolean(inbox.contactSelected)
  const last_interaction = new Date().toISOString()
  const length = inbox.conversation?.conversation?.length

  console.log('to:', to)
  console.log('inbox.to.current.value', inbox.to.current.value)

  dispatch(
    sendSMSInbox({
      contact_id,
      text,
      contact,
      to: toValue,
      from_number,
      contactSelected,
      last_interaction,
      length,
    }),
  ).then(() =>
    dispatch(
      read(
        contactSelected?.id || contact_id,
        'inbox',
        'inbox/conversation',
        'contact_id',
      ),
    ).then(() =>
      dispatch(selectConversation(contactSelected?.id || contact_id)),
    ),
  )
}
